import { Controller } from '@hotwired/stimulus'

// Collapses long profile copy to a word limit with a Read more / Show less toggle.
export default class ClampController extends Controller {
  static readonly targets = ['text']
  static readonly values = { words: { type: Number, default: 30 } }

  declare textTarget: HTMLElement
  declare wordsValue: number

  fullHtml = ''
  shortHtml = ''
  expanded = false
  toggle: HTMLButtonElement | null = null

  connect() {
    this.fullHtml = this.textTarget.innerHTML
    const words = (this.textTarget.textContent || '').replace(/\s+/g, ' ').trim().split(' ').filter(Boolean)
    if (words.length <= this.wordsValue) return

    this.shortHtml = `<p>${words.slice(0, this.wordsValue).join(' ')}…</p>`
    this.toggle = this.buildToggle()
    this.element.append(this.toggle)
    this.render()
  }

  buildToggle() {
    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'read-more'
    button.setAttribute('aria-expanded', 'false')
    if (this.textTarget.id) button.setAttribute('aria-controls', this.textTarget.id)
    button.addEventListener('click', () => {
      this.expanded = !this.expanded
      this.render()
    })
    return button
  }

  render() {
    if (!this.toggle) return

    this.textTarget.innerHTML = this.expanded ? this.fullHtml : this.shortHtml
    this.toggle.setAttribute('aria-expanded', String(this.expanded))
    this.toggle.innerHTML = this.expanded
      ? 'Show less <span class="read-more-icon --open" aria-hidden="true"></span>'
      : 'Read more <span class="read-more-icon" aria-hidden="true"></span>'
  }
}
